import React, { useRef, useState } from "react";
import { Button, Card, Divider, Tabs } from "antd";
import RoForm from "./RoForm";
import RoDetailList from "./RoDetailList";
import { ProfileTwoTone } from "@ant-design/icons";
import { useModelDispatchers } from "../../../models";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import { goPage } from "../../layout/pageDefinition";
import { useHistory } from "react-router";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const { closeNav } = useModelDispatchers("nav");

    const history = useHistory();
    const formRef = useRef();
    const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);

    const getForm = () => {
        return formRef.current.form();
    };
    const onSave = () => {
        formRef.current.insert(setSaveBtnDisabled);
    }
    const onBack = () => {
        closeNav();
        goPage(history, "2-4");
    }

    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">新增采购退货单</span>
                </h3>
                <div style={{ width: "600px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.PR_AD_SAVE}>
                        <Button
                            className="margin-left-8"
                            type="primary"
                            onClick={onSave}
                            disabled={saveBtnDisabled}>保存
                            </Button>
                    </YhAuth>
                    <Button className="margin-left-8" onClick={onBack}>返回</Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            <RoForm formRef={formRef} actionType={CM_ACTION_TYPE.INSERT} />
            <Divider orientation="left" />
            <RoDetailList getForm={getForm} />
        </Card>
    );
}